module.exports = __webpack_public_path__ + "img/Academico.5e345597.png";